function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 79",
  d: "M13.741 25.865H2.425A2.426 2.426 0 010 23.44v-6.238a7.261 7.261 0 013.233-6.048l7.493-5 .9 1.345-7.486 4.99a5.645 5.645 0 00-2.52 4.707v6.238a.809.809 0 00.808.808h11.313a.809.809 0 00.808-.808V6.466h1.617V23.44a2.426 2.426 0 01-2.425 2.425z",
  fill: "#17457a"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 80",
  d: "M16.974 4.85h-6.467a.809.809 0 01-.808-.809V.808A.809.809 0 0110.507 0h6.466a.809.809 0 01.808.808v3.233a.809.809 0 01-.807.809zm-5.658-1.617h4.85V1.617h-4.85z",
  fill: "#17457a"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 81",
  d: "M8.649 21.953a2.994 2.994 0 01-2.991-2.991 15.573 15.573 0 012.3-5.968.839.839 0 011.167-.212.85.85 0 01.212.212 15.544 15.544 0 012.3 5.968 2.994 2.994 0 01-2.988 2.991zm0-6.887a10.768 10.768 0 00-1.374 3.9 1.374 1.374 0 102.748 0 10.708 10.708 0 00-1.374-3.9z",
  fill: "#17457a"
});

function SvgOilCan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 211",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.782 25.865",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOilCan);
export default __webpack_public_path__ + "static/media/oilCan.21a3682a.svg";
export { ForwardRef as ReactComponent };